import PropTypes from 'prop-types'
import React from 'react'

import './WavyHeading.scss'
import WavyLine from './WavyLine'

const WavyHeading = ({ text, waveColour }) => {
  return (
    <div className="wavy-heading">
      <h3 className="wavy-heading__text">{text}</h3>
      <WavyLine stroke={waveColour} />
    </div>
  )
}

WavyHeading.propTypes = {
  text: PropTypes.string.isRequired,
  waveColour: PropTypes.string,
}

export default WavyHeading
